import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { PredefinedDiscoverCollectionsCollection } from './predefined-discover-collections.types';

export function predefinedDiscoverCollectionsBackend(): Backend<PredefinedDiscoverCollectionsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => {
      const [collectionType] = getQueryParamValue(query, 'type');
      if (!collectionType) {
        throw new Error('You must specify the collection type.');
      }

      return {
        endpoint: `users/0.1/discover_collection/${collectionType}`,
        method: 'GET',
        isGaf: false,
      };
    },
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
